import React, { Component } from 'react';
import Heading from '../components/Heading';

export default class NotFound extends Component {
  render() {
    return (
      <div className="not-found">
        <Heading text="404 Not Found" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/NotFound.jsx